export function checkAdDisclaimer(bylines) {
  return bylines.some(byline => byline.description_id === '6');
}
